import { alpha, Typography } from '@mui/material';
import { theme as dsTheme } from '@sb/cc-design-system';
import { isEmpty } from 'lodash';
import React from 'react';
import EmptyIcon from 'src/assets/images/Empty.svg';
import { lang } from 'src/utils';

import { EmptyImg, EmptyWrapper } from './EmptyProvider.styled';

export interface IEmpty {
  isLoading?: boolean;
  dataToCheck?: any;
  message?: string | React.ReactNode;
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
  children?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
}

export const EmptyProvider = (props: IEmpty) => {
  const {
    isLoading = false,
    dataToCheck = [],
    image,
    message,
    imageWidth,
    imageHeight,
    children,
  } = props;

  if (isLoading) {
    return null;
  }

  if (!isEmpty(dataToCheck)) {
    return children!;
  }

  return (
    <EmptyWrapper>
      <EmptyImg
        src={image ?? EmptyIcon}
        alt="emptyIcon"
        data-testid="emptyIcon"
        draggable={false}
        $imageWidth={imageWidth}
        $imageHeight={imageHeight}
      />
      <Typography
        variant="body2"
        color={alpha(dsTheme.palette.secondary.contrastText, 0.38)}>
        {message ?? lang.noResultText}
      </Typography>
    </EmptyWrapper>
  );
};
